import React from "react";
import "./index.scss";

function Events() {
  return (
    <div className="events-container">
      <h1>No events to show!</h1>
    </div>
  );
}

export default Events;
